import React from 'react'

const Qualification = (props) => {
    return (
        <li className="p-0 col-span-1 flex"><p className="p-0 !m-0 text-sm"><span className="font-bold dark:text-sky-300 text-sky-500 uppercase text-base">{props.category}</span><br />{props.list.join(" / ")}</p></li>
    )
}

export default Qualification;